"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Loupe = _interopRequireDefault(require("./../Icons/Loupe"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ActionButton = _interopRequireDefault(require("../Buttons/ActionButton"));

var _SmallLoader = _interopRequireDefault(require("../Loaders/SmallLoader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SearchInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      border = _ref.border,
      icon = _ref.icon,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      text = _ref.text,
      showButton = _ref.showButton,
      buttonText = _ref.buttonText,
      buttonAction = _ref.buttonAction,
      loading = _ref.loading,
      onClear = _ref.onClear,
      otherProps = _objectWithoutProperties(_ref, ["className", "border", "icon", "onChange", "placeholder", "text", "showButton", "buttonText", "buttonAction", "loading", "onClear"]);

  var handleChange = function handleChange(_ref2) {
    var value = _ref2.target.value;
    onChange(value);
  };

  return /*#__PURE__*/_react.default.createElement(StyledBox, null, !loading ? icon : /*#__PURE__*/_react.default.createElement(_SmallLoader.default, null), /*#__PURE__*/_react.default.createElement(Input, _extends({
    ref: ref,
    className: className,
    type: "text",
    name: "search",
    placeholder: placeholder,
    value: text,
    border: border,
    onChange: handleChange
  }, otherProps)), text ? /*#__PURE__*/_react.default.createElement(ClearButton, {
    onClick: onClear
  }, "X") : '', showButton ? /*#__PURE__*/_react.default.createElement(_ActionButton.default, {
    level: "secondary",
    onClick: buttonAction
  }, buttonText) : '');
});

var StyledBox = _styledComponents.default.div.withConfig({
  displayName: "StyledBox"
})(["position:relative;width:100%;height:4rem;display:flex;justify-content:flex-start;align-items:center;svg{transform:rotate(-90deg);flex:0 0 30px;path{fill:", ";}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.ui.interactive;
});

var Input = _styledComponents.default.input.withConfig({
  displayName: "Input"
})(["font-family:", ";font-size:1.4rem;color:", ";border:", ";line-height:120%;padding:0.3rem 1rem;background-color:transparent;flex:1 0 auto;height:100%;box-sizing:border-box;&:focus{outline:none;box-shadow:0;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.font;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.labels.guaranteeText;
}, function (_ref6) {
  var border = _ref6.border,
      theme = _ref6.theme;
  return border ? "1px solid ".concat(theme.ui.disabled) : 'none';
});

var ClearButton = _styledComponents.default.div.withConfig({
  displayName: "ClearButton"
})(["display:flex;justify-content:center;align-items:center;width:1.5rem;height:1.5rem;background-color:", ";border-radius:9999px;font-family:", ";font-size:0.8rem;color:white;margin:0 2rem;cursor:pointer;flex:0 0 1.5rem;&:hover{background-color:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.ui.outline;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.font;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.brand.primary;
});

Input.displayName = 'Input';
SearchInput.displayName = 'SearchInput';
SearchInput.defaultProps = {
  className: '',
  border: false,
  icon: /*#__PURE__*/_react.default.createElement(_Loupe.default, null),
  onChange: Function.prototype,
  placeholder: 'Search for name, status, ...',
  text: '',
  showButton: false,
  buttonText: 'Search',
  buttonAction: function buttonAction() {
    return console.log('Pass a click function for your search');
  },
  otherProps: {},
  loading: false
};
SearchInput.propTypes = {
  className: _propTypes.string,
  border: _propTypes.bool,
  icon: _propTypes.node,
  onChange: _propTypes.func,
  placeholder: _propTypes.string,
  text: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  showButton: _propTypes.bool,
  buttonText: _propTypes.string,
  buttonAction: _propTypes.func,
  otherProps: _propTypes.object,

  /** Set this to true when calling an API to display a loading state in the search bar... */
  loading: _propTypes.bool,

  /** Function passed to the clear button */
  onClear: _propTypes.func
};
var _default = SearchInput;
exports.default = _default;